module.exports = __webpack_public_path__ + "static/media/gdocs.bbea5316.png";